import * as yup from 'yup';

export const QUESTION_TYPE = {
  shortAnswer: 1,
  longAnswer: 2,
  date: 3,
  number: 4,
  yesNo: 5,
  file: 6,
  option: 7,
  table: 8,
  contact: 9,
  basicContact: 10,
  multiselect: 11,
  statement: 99,
};

export const validationText = {
  [QUESTION_TYPE.basicContact]: 'Contact is required',
  [QUESTION_TYPE.contact]: 'Contact is required',
  [QUESTION_TYPE.date]: 'Date is required',
  [QUESTION_TYPE.file]: 'File is required',
  [QUESTION_TYPE.fullAnswer]: 'This field is required',
  [QUESTION_TYPE.longAnswer]: 'This field is required',
  [QUESTION_TYPE.multiselect]: 'At least one option must be selected',
  [QUESTION_TYPE.number]: 'This field is required',
  [QUESTION_TYPE.option]: 'An option must be selected',
  [QUESTION_TYPE.shortAnswer]: 'This field is required',
  [QUESTION_TYPE.table]: 'Table entries are incomplete',
  [QUESTION_TYPE.yesNo]: 'Yes or no must be selected',
};

export const generateInputName = (type, questionId) => `${type}-${questionId}`;

const getOptionValidation = ({ allowsMultiselect }) => {
  const optionRequiredMessage = validationText[QUESTION_TYPE.option];

  if (allowsMultiselect) {
    return yup
      .array()
      .of(
        yup.object().shape({
          value: yup.string().required(optionRequiredMessage),
          label: yup.string().required(),
        })
      )
      .min(1, optionRequiredMessage)
      .required(optionRequiredMessage);
  }

  return yup.string().required(optionRequiredMessage);
};

const getYesNoValidation = () => yup.boolean().required(validationText[QUESTION_TYPE.yesNo]);

const getFileValidation = () => {
  const requiredMessage = validationText[QUESTION_TYPE.file];

  return yup.mixed().test('file-upload-required', requiredMessage, (value) => {
    if (value && typeof value === 'boolean') {
      return true;
    } else if (value && value.length > 0) {
      return true;
    } else {
      return false;
    }
  });
};
const getTableValidation = () => yup.object().required(validationText[QUESTION_TYPE.table]);

const getContactValidation = () =>
  yup.array().min(1, validationText[QUESTION_TYPE.contact]).required(validationText[QUESTION_TYPE.contact]);

const questionTypeValidations = {
  [QUESTION_TYPE.option]: getOptionValidation,
  [QUESTION_TYPE.file]: getFileValidation,
  [QUESTION_TYPE.yesNo]: getYesNoValidation,
  [QUESTION_TYPE.table]: getTableValidation,
  [QUESTION_TYPE.contact]: getContactValidation,
  [QUESTION_TYPE.basicContact]: getContactValidation,
};

export const getQuestionValidation = (props) => {
  let { questionTypeId } = props;

  if (questionTypeId === QUESTION_TYPE.basicContact) {
    questionTypeId = QUESTION_TYPE.contact;
  }
  return questionTypeValidations?.[questionTypeId]?.(props) || yup.string().required(validationText[questionTypeId]);
};

export const setQuestionVisibility = (question, jpaQuestionVisibility) => {
  question.isVisible = jpaQuestionVisibility[question.jpaQuestionID];
};

export const generateValidation = (sections, jpaQuestionVisibility, isSectionHidden) => {
  const validation = {};
  if (isSectionHidden) {
    return validation;
  }
  sections?.forEach((section) => {
    section?.jpaQuestions?.forEach((question) => {
      setQuestionVisibility(question, jpaQuestionVisibility);
      if (question.isVisible && question.isRequired) {
        const name = generateInputName(question.jpaQuestionTypeID, question.jpaQuestionID);

        validation[name] = getQuestionValidation({
          allowsMultiselect: question?.allowsMultiselect,
          questionTypeId: question?.jpaQuestionTypeID,
        });
      }
    });
  });
  return validation;
};
